/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreditPoolInfo interface.
 */
export function instanceOfCreditPoolInfo(value) {
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
export function CreditPoolInfoFromJSON(json) {
    return CreditPoolInfoFromJSONTyped(json, false);
}
export function CreditPoolInfoFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amount': json['amount'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'grantedAt': json['grantedAt'] == null ? undefined : (new Date(json['grantedAt'])),
        'id': json['id'],
        'source': json['source'],
    };
}
export function CreditPoolInfoToJSON(json) {
    return CreditPoolInfoToJSONTyped(json, false);
}
export function CreditPoolInfoToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amount': value['amount'],
        'expiresAt': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
        'grantedAt': value['grantedAt'] == null ? value['grantedAt'] : value['grantedAt'].toISOString(),
        'id': value['id'],
        'source': value['source'],
    };
}
